/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Carousel from './modules/carousel';
import CopyToClipboard from './modules/copy-to-clipboard';
import Map from './modules/map';
import PageNav from './modules/page-nav';
import SiteHead from './modules/site-head';
import Share from './modules/share';
import Tabs from './modules/tabs';
import UpcomingEntries from './modules/upcoming-entries';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'site-head':
                        let siteHeadInstance = new SiteHead(item);
                        siteHeadInstance.init();
                        break;

                    case 'carousel':
                        let carouselInstance = new Carousel(item);
                        carouselInstance.init();
                        break;

                    case 'copy-to-clipboard':
                        let copyToClipboardInstance = new CopyToClipboard(item);
                        copyToClipboardInstance.init();
                        break;

                    case 'map':
                        let mapInstance = new Map(item);
                        mapInstance.init();
                        break;

                    case 'page-nav':
                        let pageNavInstance = new PageNav(item);
                        pageNavInstance.init();
                        break;

                    case 'share':
                        let shareInstance = new Share(item);
                        shareInstance.init();
                        break;

                    case 'tabs':
                        let tabsInstance = new Tabs(item);
                        tabsInstance.init();
                        break;

                    case 'upcoming-entries':
                        let upcomingEntriesInstance = new UpcomingEntries(item);
                        upcomingEntriesInstance.init();
                        break;
                }
            });
        });
    },

    alwaysLoad() {

    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
